import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13\" id=\"icon-back\">\n  <path id=\"icon-back_路径_9381\" data-name=\"路径 9381\" d=\"M239.138,327s-.137.369-.32,0c0,0-2.042-6.443-7.02-4.82v2s-.08,1.176-1.061.41l-4.894-4.417s-1.038-.59.063-1.4l4.947-4.443s.744-.554.923.355l.005,2.158S241.058,317.312,239.138,327Z\" transform=\"translate(-225.399 -314.166)\" fill=\"#357ce1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/back.svg
// module id = RN8c
// module chunks = 102